<div *ngIf="(collections$ | async), else loadingTemplate" class="content">

  <scs-search></scs-search>

  <scs-citations-queue></scs-citations-queue>
  
  <div
    class="scroll-wrapper scroll-wrapper--sm scrollbar padding-top-sm"
    [style.height]="containerHeight"
    [ngClass]="{ 'hidden': (itemsDisplayService.itemsVisible$ | async) }">

    <ng-container>
      <div class="label">Active</div>

      <navigation-button
        (click)="openActiveReferences()">
        <ng-container icon>
          <fa-icon [icon]="['fas', 'list']" class="padding-left-xxs"></fa-icon>
        </ng-container> List of active references
      </navigation-button>
    </ng-container>
  
    <div class="label">Personal Library</div>

    <ng-container *ngIf="!(activeReferencesService.createListLoading$ | async)">
      <navigation-collection
        [collection]="privateCollection$ | async">
      </navigation-collection>
    </ng-container>

    <div class="label">Shared Libraries</div>

    <navigation-collection-shared
      *ngFor="let collection of sharedCollections$ | async; trackBy: collectionTrackByFn;"
      [collection]="collection">
    </navigation-collection-shared>

  </div>

  <scs-items
    id="scroll-wrapper-items"
    class="scroll-wrapper scroll-wrapper--sm scrollbar"
    [style.height]="containerHeight"
    [ngClass]="{'hidden': !(itemsDisplayService.itemsVisible$ | async)}">
  </scs-items>

  <scs-citation-drawer *ngIf="isCitationDrawerVisible"></scs-citation-drawer>

  <scs-active-references
    [personalCollection]="privateCollection$ | async"
    [sharedCollections]="sharedCollections$ | async"
    [isCitationDrawerVisible]="isCitationDrawerVisible"
    class="references-box_container" 
    *ngIf="activeReferencesService.areActiveReferencesShown">
  </scs-active-references>

</div>

<ng-template #loadingTemplate>
  <div class="loader_overlay">
    <scs-loader class="center-horizontal-vertical"></scs-loader>
  </div>
</ng-template>